<template>
  <div>
    <div ref="editor" :class="isInput ? 'showInput' : 'showTextarea'"></div>
  </div>
</template>

<script>
import E from 'wangeditor'

export default {
  name: 'Editor',
  data () {
    const actionUrl = this.$sysInfo.apiRemote + '/subject/file'
    const preViewImgUrl = this.$sysInfo.apiRemote + `/subject/file`
    return {
      editorContent: '',
      headers: {
        Authorization: this.$store.state.user.token
      },
      editor: null,
      isInput: true,
      actionUrl,
      preViewImgUrl
    }
  },
  methods: {
    setContent (content) {
      // console.log('content', content)
      this.editorContent = content
      this.editor.txt.html(content)
    },
    setStyle (bool) {
      this.isInput = bool
    }
  },
  mounted () {
    // var editor = new E(this.$refs.toolbar, this.$refs.textArea)
    var editor = new E(this.$refs.editor)
    var preViewImgUrl = this.preViewImgUrl
    var vm = this
    this.editor = editor
    editor.customConfig.onchange = html => {
      this.editorContent = html
    }

    // // 将图片大小限制为 2M
    editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024
    // // 响应时间
    editor.customConfig.uploadImgTimeout = 50000

    // // 配置服务器端地址
    editor.customConfig.uploadImgServer = this.actionUrl

    editor.customConfig.uploadImgParams = {
      // 如果版本 <=v3.1.0 ，属性值会自动进行 encode ，此处无需 encode
      // 如果版本 >=v3.1.1 ，属性值不会自动 encode ，如有需要自己手动 encode
      Authorization: this.$store.state.user.token
    }

    editor.customConfig.uploadImgHeaders = {
      Authorization: this.$store.state.user.token
    }

    editor.customConfig.customAlert = function (info) {
      // info 是需要提示的内容
    }

    editor.customConfig.uploadImgHooks = {
      before: function (xhr, editor, files) {
        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
      },
      success: function (xhr, editor, result) {
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      fail: function (xhr, editor, result) {
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      error: function (xhr, editor) {
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },
      timeout: function (xhr, editor) {
        // 图片上传超时时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },

      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function (insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：

        if (result.status === 0) {
          const filePath = preViewImgUrl + `/${result.data}`
          // insertImg(filePath)
          editor.cmd.do('insertHTML', '<p><img src="' + filePath + '" width="80px" height="80px"></p>')
        } else {
          vm.$message.error(result.info.message)
        }
      }
    }

    editor.customConfig.uploadFileName = 'file'
    // 自定义菜单配置

    if (this.$auth('itemBank.upload')) {
      editor.customConfig.menus = ['image', 'undo', 'redo']
    } else {
      editor.customConfig.menus = ['undo', 'redo']
    }

    editor.create()
  }

}
</script>

<style lang="less">
.showInput {
  border-top: 1px solid #ccc;

  .w-e-toolbar {
    display: none;
  }

  .w-e-text-container {
    height: 32px !important;
    line-height: 32px;
    p {
      margin: 0;
      line-height: inherit;
    }
  }
}

.showTextarea {
  // border:1px solid red;
  .w-e-toolbar {
    display: flex;
  }

  .w-e-text-container {
    height: 100px !important;
  }
}
</style>
